package com.milta.core.localization.translations.pl

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Anuluj",
    confirm = "Potwierdź",
    save = "Zapisz",
    delete = "Usuń",
    back = "Wstecz",
    loading = "Ładowanie…",
    retry = "Spróbuj ponownie",
    language = "Język",
    welcomeTitle = "Witaj w Milta",
    welcomeSubtitle = "Twój inteligentny asystent dostaw",
    alreadyHaveAccount = "Mam już konto",
    createAccount = "Utwórz konto",
    continueWithGoogle = "Kontynuuj z Google",
    continueWithApple = "Kontynuuj z Apple",
    oauthErrorGeneric = "Wystąpił błąd podczas logowania. Spróbuj ponownie.",
    oauthAppleWebComingSoon = "Logowanie przez Apple będzie wkrótce dostępne w wersji internetowej.",
    oauthDriverAccountNotAllowedOnWeb = "Konta kierowców nie mają dostępu do panelu internetowego. Zaloguj się przez aplikację mobilną.",
    oauthAccountNotFoundOnWeb = "Nie znaleziono konta Milta dla tego konta Google.",
    errorOffline = "Brak połączenia z internetem.",
    navTourneesDuJour = "Dzisiejsze trasy",
    navAjouterUneTournee = "Dodaj trasę",
    navHistoriqueDesPreuves = "Historia dostaw",
    navParametres = "Ustawienia",
    sidebarRoleManagerLabel = "Menedżer",
    noDeliveriesYetTitle = "Brak dostaw",
    noDeliveriesYetSubtitle = "Dotknij „Dodaj dostawy”, aby je dodać",
    optimizationUnavailableExplanation = "Czy chcesz utworzyć trasę bez optymalizacji, czy spróbować ponownie?",
    createWithoutOptimizationAction = "Utwórz bez optymalizacji",
    gpsAppSheetTitle = "Wybierz aplikację nawigacyjną",
    addressSearchingLabel = "Wyszukiwanie…",
)
